import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup, { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { Button, Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';
import './style.css';
import LeadStore from '../../store/LeadStore';
import { SendNotificationUserDialog } from '../SendNotificationUserDialog';
import { toJS } from 'mobx';
import { datetimeFormatter } from '../../utils/datetimeFormatter';
import { NewLeadActionDialog } from '../NewLeadActionDialog';
import UserStore from '../../store/UserStore';
import { NewLeadCallDialog } from '../NewLeadCallDialog';
import { NewLeadPaymentAuditDialog } from '../NewLeadPaymentAuditDialog';
import DocumentStore from '../../store/DocumentStore';
import { UploadLeadDocDialog } from '../UploadLeadDocDialog';
import { isEmpty } from '../../utils/helper';
import ClientDetails from './SubPages/ClientDetails';
import SiteDetails from './SubPages/SiteDetails';
import PackagePayment from './SubPages/PackagePayment';
import LeadOwners from './SubPages/LeadOwners';
import UpSell from './SubPages/UpSell';
import CommonSection from './SubPages/CommonUpperSection';
import CommonBottomSection from './SubPages/CommonBottomSection';
import ProjectTimeLineDetails from './SubPages/ProjectTimeLineDetails';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
    marginLeft: -1,
    borderLeft: '1px solid transparent',
  },
}));

export const LeadDetails = observer(() => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const leadId = queryParams.get('leadId');
  const pipelineId = queryParams.get('pId');

  const [leadDetails, setLeadDetails] = useState(null);
  const [priorities, setPriorities] = useState([]);
  const [leadTimeLines, setLeadTimeLines] = useState([]);
  const [workflowStatusByPipeLine, setWorkflowStatusByPipeLine] = useState([]);
  const [editLeadDetails, setEditLeadDetails] = useState(false);
  const [editClientInfo, setEditClientInfo] = useState(false);
  const [uploadFilesDocumentType, setUploadFilesDocumentType] = useState('');
  const [editSiteDetails, setEditSiteDetails] = useState(false);
  const [editAdditionalServiceRequired, setEditAdditionalServiceRequired] = useState(false);
  const [editPcpDetails, setEditPcpDetails] = useState(false);
  const [editProcessProcedureCompoleted, setEditProcessProcedureCompoleted] = useState(false);
  const [editClientPersonalInfo, setEditClientPersonalInfo] = useState(false);
  const [editProjectTimeLineDetails, setEditProjectTimeLineDetails] = useState(false);
  const [editBuildingDesignDetails, setEditBuildingDesignDetails] = useState(false);
  const [editResidentialBuildingDetails, setEditResidentialBuildingDetails] = useState(false);
  const [editConstructionSpecification, setEditConstructionSpecification] = useState(false);
  const [toggleSendNotificationDialog, setToggleSendNotificationDialog] = useState(false);
  const [toggleNewLeadActionDialog, setToggleNewLeadActionDialog] = useState(false);
  const [leadActionDetails, setLeadActionDetails] = useState(null);
  const [toggleNewLeadCallDialog, setToggleNewLeadCallDialog] = useState(false);
  const [leadCallDetails, setLeadCallDetails] = useState(null);
  const [toggleNewLeadPaymentAuditDialog, setToggleNewLeadPaymentAuditDialog] = useState(false);
  const [leadPaymentAuditDetails, setLeadPaymentAuditDetails] = useState(null);
  const [toggleUploadLeadDocDialogDialog, setToggleUploadLeadDocDialogDialog] = useState(false);

  const [selectedSection, setSelectedSection] = useState('clientDetails');

  const handleEditLeadDetails = () => {
    setEditLeadDetails(!editLeadDetails);
  };

  const handleEditClientInfo = () => {
    setEditClientInfo(!editClientInfo);
  };

  const handleEditSiteDetails = () => {
    setEditSiteDetails(!editSiteDetails);
  };

  const handleEditAdditionalServiceRequired = () => {
    setEditAdditionalServiceRequired(!editAdditionalServiceRequired);
  };

  const handleEditPcpDetails = () => {
    setEditPcpDetails(!editPcpDetails);
  };

  const handleEditProcessProcedureCompoleted = () => {
    setEditProcessProcedureCompoleted(!editProcessProcedureCompoleted);
  };

  const handleEditClientPersonalInfo = () => {
    setEditClientPersonalInfo(!editClientPersonalInfo);
  };

  const handleEditProjectTimeLineDetails = () => {
    setEditProjectTimeLineDetails(!editProjectTimeLineDetails);
  };

  const handleEditBuildingDesignDetails = () => {
    setEditBuildingDesignDetails(!editBuildingDesignDetails);
  };

  const handleEditResidentialBuildingDetails = () => {
    setEditResidentialBuildingDetails(!editResidentialBuildingDetails);
  };

  const handleEditConstructionSpecification = () => {
    setEditConstructionSpecification(!editConstructionSpecification);
  };

  const handleToggleNotifyUserDialog = (show) => {
    setToggleSendNotificationDialog(show);
  };

  const handleToggleNewLeadActionDialog = () => {
    setToggleNewLeadActionDialog(!toggleNewLeadActionDialog);
  };
  const handleToggleLeadActionDialog = (toggle, details) => {
    setLeadActionDetails(details);
    setToggleNewLeadActionDialog(toggle);
  };

  const handleToggleNewLeadCallDialog = () => {
    setToggleNewLeadCallDialog(!toggleNewLeadCallDialog);
  };
  const handleToggleLeadCallDialog = (toggle, details) => {
    setLeadCallDetails(details);
    setToggleNewLeadCallDialog(toggle);
  };

  const handleToggleNewLeadPaymentAuditDialog = () => {
    setToggleNewLeadPaymentAuditDialog(!toggleNewLeadPaymentAuditDialog);
  };
  const handleToggleLeadPaymentAuditDialog = (toggle, details) => {
    setLeadPaymentAuditDetails(details);
    setToggleNewLeadPaymentAuditDialog(toggle);
  };

  const handleToggleUploadLeadDocDialogDialog = () => {
    setToggleUploadLeadDocDialogDialog(!toggleUploadLeadDocDialogDialog);
  };

  useEffect(() => {
    !isEmpty(uploadFilesDocumentType) && handleToggleUploadLeadDocDialogDialog();
  }, [uploadFilesDocumentType]);

  const [alignment, setAlignment] = useState('left');
  const [formats, setFormats] = useState(() => ['italic']);

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  useEffect(() => {
    UserStore.fetchUsersDropDown();
    LeadStore.getDetailedLead(leadId);
    LeadStore.getLeadStatusTimeLine(leadId);
    LeadStore.getWorkflowStatusByPipeLineId(pipelineId);
    DocumentStore.getLeadDocumentNamesByLeadId(leadId);
  }, [leadId, pipelineId]);

  useEffect(() => {
    LeadStore.getDetailedLead(leadId);
  }, [LeadStore.refreshLeadDetails]);

  useEffect(() => {
    !editLeadDetails && LeadStore.getLeadStatusTimeLine(leadId);
  }, [editLeadDetails]);

  useEffect(() => {
    setPriorities(toJS(LeadStore.priorities));
  }, [LeadStore.priorities]);

  useEffect(() => {
    setWorkflowStatusByPipeLine(toJS(LeadStore.workflowStatusByPipeLine));
  }, [LeadStore.workflowStatusByPipeLine]);

  useEffect(() => {
    setLeadTimeLines(LeadStore.leadTimeLines);
    setTimeout(() => {
      highlightFirst();
    }, 500);
  }, [LeadStore.leadTimeLines]);

  useEffect(() => {
    LeadStore.getPriorities();
  }, []);

  useEffect(() => {
    setLeadDetails(toJS(LeadStore.leadDetails));
  }, [LeadStore.leadDetails]);

  useEffect(() => {
    DocumentStore.uploadDocumentStatus && DocumentStore.getLeadDocumentNamesByLeadId(leadId);
  }, [DocumentStore.uploadDocumentStatus]);

  const handleRemoveDocument = (fileId) => {
    DocumentStore.deleteDocument(fileId);
  };

  useEffect(() => {
    DocumentStore.documentDeleteStatus && DocumentStore.getLeadDocumentNamesByLeadId(leadId);
  }, [DocumentStore.documentDeleteStatus]);

  useEffect(() => {
    DocumentStore.documentDownloadFile && downloadFile(toJS(DocumentStore.documentDownloadFile));
  }, [DocumentStore.documentDownloadFile]);

  const downloadFile = async ({ file, fileName }) => {
    const byteArray = new Uint8Array(file.length);

    for (let i = 0; i < file.length; i++) {
      byteArray[i] = file.charCodeAt(i);
    }
    const blob = new Blob([file], { type: 'application/pdf' });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      link.remove();
      window.URL.revokeObjectURL(url);
    }, 100);
  };

  const handleDownload = async (doc) => {
    DocumentStore.downloadDocumentFromS3(doc.id, doc.documentName);
  };

  const handlePreviewFile = (doc) => {
    window.open(doc.documentRefUrl, '_blank');
  };

  const highlightFirst = () => {
    let timelineSteps = document.querySelector('#timeline-stepper')?.children;
    if (timelineSteps?.length) {
      let leftPosition = timelineSteps[0].offsetLeft;
      for (let step of timelineSteps) {
        step.classList[step.offsetLeft <= leftPosition ? 'add' : 'remove']('remove-multi-step-connector');
      }
    }
  };

  window.addEventListener('resize', highlightFirst);

  const handleSectionChange = (section) => {
    setSelectedSection(section);
  };

  return leadDetails !== null ? (
    <Stack spacing={3}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Paper
          id="lh-tab-view"
          sx={{
            borderRadius: '25px',
            display: 'flex',
            border: (theme) => `1px solid ${theme.palette.divider}`,
            flexWrap: 'wrap',
          }}
        >
          <StyledToggleButtonGroup
            size="small"
            value={alignment}
            exclusive
            disabled={true}
            onChange={handleAlignment}
            aria-label="text alignment"
          >
            <ToggleButton size="small" value="left" aria-label="centered">
              Overview
            </ToggleButton>
          </StyledToggleButtonGroup>
        </Paper>
        <Paper
          sx={{
            boxShadow: 'none',
            fontSize: '14px',
            fontWeight: '500',
            background: 'transparent',
          }}
        >
          Last update:{' '}
          {leadDetails.leadUpdatedDate
            ? datetimeFormatter.formatDateTime(leadDetails.leadUpdatedDate, datetimeFormatter.toLocal)
            : ''}
        </Paper>
      </Stack>
      <Paper>
        <div className="flex justify-between items-center px-8 py-3">
          <Button
            sx={{ textTransform: 'none' }}
            variant={selectedSection === 'clientDetails' ? 'contained' : 'text'}
            onClick={() => handleSectionChange('clientDetails')}
          >
            Client Details
          </Button>
          <Button
            sx={{ textTransform: 'none' }}
            variant={selectedSection === 'siteDetails' ? 'contained' : 'text'}
            onClick={() => handleSectionChange('siteDetails')}
          >
            Site Details
          </Button>
          <Button
            sx={{ textTransform: 'none' }}
            variant={selectedSection === 'projectTimeLineDetails' ? 'contained' : 'text'}
            onClick={() => handleSectionChange('projectTimeLineDetails')}
          >
            Project Timeline Details
          </Button>
          <Button
            sx={{ textTransform: 'none' }}
            variant={selectedSection === 'packagePayment' ? 'contained' : 'text'}
            onClick={() => handleSectionChange('packagePayment')}
          >
            Package & Payment Details
          </Button>
          <Button
            sx={{ textTransform: 'none' }}
            variant={selectedSection === 'leadOwners' ? 'contained' : 'text'}
            onClick={() => handleSectionChange('leadOwners')}
          >
            Lead Owners
          </Button>
          <Button
            sx={{ textTransform: 'none' }}
            variant={selectedSection === 'upSell' ? 'contained' : 'text'}
            onClick={() => handleSectionChange('upSell')}
          >
            Upsell
          </Button>
        </div>
      </Paper>
      <CommonSection
        leadTimeLines={leadTimeLines}
        leadDetails={leadDetails}
        workflowStatusByPipeLine={workflowStatusByPipeLine}
      />
      {selectedSection === 'clientDetails' && (
        <>
          <ClientDetails
            leadDetails={leadDetails}
            handleToggleNotifyUserDialog={handleToggleNotifyUserDialog}
            editLeadDetails={editLeadDetails}
            handleEditLeadDetails={handleEditLeadDetails}
            selectedLead={leadId}
            workflowStatusByPipeLine={workflowStatusByPipeLine}
            priorities={priorities}
          />
          <UpSell
            editClientPersonalInfo={editClientPersonalInfo}
            leadDetails={leadDetails}
            handleEditClientPersonalInfo={handleEditClientPersonalInfo}
          />
        </>
      )}
      {selectedSection === 'siteDetails' && (
        <SiteDetails
          editBuildingDesignDetails={editBuildingDesignDetails}
          handleEditBuildingDesignDetails={handleEditBuildingDesignDetails}
          editResidentialBuildingDetails={editResidentialBuildingDetails}
          handleEditResidentialBuildingDetails={handleEditResidentialBuildingDetails}
          editConstructionSpecification={editConstructionSpecification}
          handleEditConstructionSpecification={handleEditConstructionSpecification}
          leadDetails={leadDetails}
          editSiteDetails={editSiteDetails}
          editAdditionalServiceRequired={editAdditionalServiceRequired}
          handleEditSiteDetails={handleEditSiteDetails}
          handleEditAdditionalServiceRequired={handleEditAdditionalServiceRequired}
        />
      )}
      {selectedSection === 'projectTimeLineDetails' && (
        <ProjectTimeLineDetails
          editProjectTimeLineDetails={editProjectTimeLineDetails}
          leadDetails={leadDetails}
          handleEditProjectTimeLineDetails={handleEditProjectTimeLineDetails}
        />
      )}
      {selectedSection === 'packagePayment' && (
        <PackagePayment
          editPcpDetails={editPcpDetails}
          handleEditPcpDetails={handleEditPcpDetails}
          leadDetails={leadDetails}
        />
      )}
      {selectedSection === 'leadOwners' && (
        <LeadOwners
          editProcessProcedureCompoleted={editProcessProcedureCompoleted}
          leadDetails={leadDetails}
          handleEditProcessProcedureCompoleted={handleEditProcessProcedureCompoleted}
        />
      )}
      {selectedSection === 'upSell' && (
        <UpSell
          editClientPersonalInfo={editClientPersonalInfo}
          leadDetails={leadDetails}
          handleEditClientPersonalInfo={handleEditClientPersonalInfo}
        />
      )}
      <CommonBottomSection
        leadDetails={leadDetails}
        handlePreviewFile={handlePreviewFile}
        setUploadFilesDocumentType={setUploadFilesDocumentType}
        handleDownload={handleDownload}
        handleRemoveDocument={handleRemoveDocument}
        handleToggleLeadActionDialog={handleToggleLeadActionDialog}
        handleToggleLeadCallDialog={handleToggleLeadCallDialog}
        handleToggleLeadPaymentAuditDialog={handleToggleLeadPaymentAuditDialog}
        editClientInfo={editClientInfo}
        handleEditClientInfo={handleEditClientInfo}
      />

      <NewLeadActionDialog
        leadDetails={leadDetails}
        leadActionDetails={leadActionDetails}
        showNewLeadActionDialog={toggleNewLeadActionDialog}
        handleShowNewLeadActionDialog={handleToggleNewLeadActionDialog}
      ></NewLeadActionDialog>
      <NewLeadCallDialog
        leadDetails={leadDetails}
        leadCallDetails={leadCallDetails}
        showNewLeadCallDialog={toggleNewLeadCallDialog}
        handleShowNewLeadCallDialog={handleToggleNewLeadCallDialog}
      ></NewLeadCallDialog>
      <NewLeadPaymentAuditDialog
        leadDetails={leadDetails}
        leadPaymentAuditDetails={leadPaymentAuditDetails}
        showNewLeadPaymentAuditDialog={toggleNewLeadPaymentAuditDialog}
        handleShowNewLeadPaymentAuditDialog={handleToggleNewLeadPaymentAuditDialog}
      ></NewLeadPaymentAuditDialog>
      <UploadLeadDocDialog
        leadDetails={leadDetails}
        uploadFilesDocumentType={uploadFilesDocumentType}
        toggleUploadLeadDocDialogDialog={toggleUploadLeadDocDialogDialog}
        handleToggleUploadLeadDocDialogDialog={handleToggleUploadLeadDocDialogDialog}
      ></UploadLeadDocDialog>
      <SendNotificationUserDialog
        notifyLeads={false}
        headerLabel="Assign Lead"
        toggleSendNotificationDialog={toggleSendNotificationDialog}
        handleToggleNotifyUserDialog={handleToggleNotifyUserDialog}
        selectedLeads={[leadId]}
        refreshLeadersBoard={true}
      ></SendNotificationUserDialog>
    </Stack>
  ) : (
    ''
  );
});